// extracted by mini-css-extract-plugin
module.exports = {"container":"ExportDetailPage_container__30tMK","imagesContainer":"ExportDetailPage_imagesContainer__1dLw2","productImage":"ExportDetailPage_productImage__y_q1j"};